import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectVacancies } from '../../selectors/vacancies';
import { FiltersLayout } from '../../components/FiltersLayout/FiltersLayout';
import { resetFilters, setSelectedFilters } from '../../actions/vacancies';
import { Typography } from '../../components/Typography';
import { fetchVacancies } from '../../actions/vacancies/fetchVacancies';
import { TThunkDispatch } from '../../types/redux';
import { Trash24 } from '../../components/Icons';

export const FiltersContainer: React.FC = () => {
  const { filters, selectedFilters } = useSelector(selectVacancies);
  const dispatch = useDispatch<TThunkDispatch>();

  const isEmptyFilters = Object.values(selectedFilters).every(values => !values.length);

  const handleSelect = (filterName: string, selectedOptions: string[]) => {
    dispatch(setSelectedFilters({ filterName, selectedOptions }));
    dispatch(fetchVacancies());
  };

  const handleTagPress = (isPressed: boolean, value: string) => {
    const selectedOptions: string[] = selectedFilters.tags || [];
    if (isPressed) {
      selectedOptions.push(value);
    } else {
      const tagIndex = selectedOptions.findIndex(tag => value === tag);
      if (tagIndex > -1) {
        selectedOptions.splice(tagIndex, 1);
      }
    }
    dispatch(setSelectedFilters({ filterName: 'tags', selectedOptions }));
    dispatch(fetchVacancies());
  };

  const handleReset = (filterName?: string) => {
    dispatch(resetFilters(filterName));
    dispatch(fetchVacancies());
  };

  const controlPanel = !isEmptyFilters ? (
    <>
      <Typography.Text fontWeight="bold" color="currentColor" level={3}>
        Сбросить все фильтры
      </Typography.Text>
      <Trash24 color="controlPrimary" />
    </>
  ) : null;

  return (
    <div>
      <FiltersLayout
        filters={filters}
        handleSelect={handleSelect}
        handlePress={handleTagPress}
        selectedFilters={selectedFilters}
        handleReset={handleReset}
        control={controlPanel}
      />
    </div>
  );
};

FiltersContainer.displayName = 'FiltersContainer';
